<template>
    <CRow>
      <CCol col="12" xl="12">
        <transition name="slide">
        <CCard>
          <CCardHeader>
            <h4>Αναφορές Πιστοποιητικών</h4>
          </CCardHeader>
          <CCardBody>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <CButton
              color="primary"
              class="mb-2"
              @click="xlsCode"
              target="_blank"
            >
              Download (.xls)
            </CButton>
            <CDataTable
              :items="dateFilteredItems"
              :fields="fields"
              :items-per-page="10"
              pagination
              column-filter
              table-filter
              hover
              :loading="loading"
              sorter
            >
                <template #certificate_no="{item}">
                    <td>
                        {{ item.certificate_no === null ? '-' : item.certificate_no}}
                    </td>
                </template>
                <template #certification_date="{item}">
                    <td>
                        {{ new Date(item.certification_date).toLocaleString().split(',')[0] }}
                    </td>
                </template>
                <template #expiration_date-filter="">
                    <span>Από:</span>
                    <input
                    type="date"
                    :value="startDate === null ? null : new Date(startDate).toISOString().substr(0, 10)"
                    @change="setDateFilter"
                    class="paddingBottomFormControl"
                    /><br>
                    <span>Έως:</span>
                    <input
                    type="date"
                    :value="endDate === null ? null : new Date(endDate).toISOString().substr(0, 10)"
                    @change="e => setDateFilter(e, 'end')"
                    />        
                </template>
                <template #expiration_date="{item}">
                    <td>
                        {{ new Date(item.expiration_date).toLocaleString().split(',')[0] }}
                    </td>
                </template>

                <template #edit="{item}">
                    <td>
                    <CButton color="primary" @click="editCase( item.id )">Επεξεργασία</CButton>
                    </td>
            </template>
          </CDataTable>
          </CCardBody>
        </CCard>
        </transition>
      </CCol>
    </CRow>
  </template>
  
  <script>
  import axios from 'axios'
  import moment from 'moment'
  import js2excel from 'js2excel';
  
  const fields = [
    {
      key: 'certificate_no', 
      label: 'Αρ. Πιστοποιητικού', 
      sorter: true, 
      filter: true
    },
    {
      key: 'company_name', 
      label: 'Πελάτης', 
      sorter: true, 
      filter: true
    },
    {
      key: 'service', 
      label: 'Πρότυπο', 
      sorter: true, 
      filter: true
    },
    {
      key: 'certification_date', 
      label: 'Ημερομηνία Έκδοσης', 
      sorter: true, 
      filter: true
    },
    {
      key: 'expiration_date', 
      label: 'Ημερομηνία Λήξης', 
      sorter: true, 
      filter: true
    },
    { 
      key: 'edit', 
      label: '', 
      sorter: false, 
      filter: false
    }
  ]
  
  export default {
    name: 'CertificationReports',
    data: () => {
      return {
        items: [],
        fields,
        startDate: new Date(),
        endDate: new Date().setDate(new Date().getDate() + 60),
        currentPage: 1,
        perPage: 5,
        totalRows: 0,
        message: '',
        showMessage: false,
        dismissCountDown: 0,
        alertIsShown: false,
        loading: true,
      }
    },
    paginationProps: {
      align: 'center',
      doubleArrows: false,
      previousButtonHtml: 'prev',
      nextButtonHtml: 'next'
    },
    computed: {
      dateFilteredItems() {
        
        if( this.startDate === null || this.endDate === null){
            return this.items;
        }else{
            const start = new Date(this.startDate);
            const end = new Date(this.endDate);
            return this.items.filter(item => {
                // const [day, month, year] = item.expiration_date.split('/');
                // const formattedDate = `${year}-${month}-${day}`;
                const date = new Date(item.expiration_date);
                return date >= start && date <= end
            })
        }
       
      }
    },
    watch: {
      alertIsShown: function(newVal, oldVal) {
        if (! newVal && this.saved) {
          this.$emit('closed-alert');
        }
      }
    },
    methods: {
      editLink (id) {
        return `certifications/${id.toString()}/edit`
      },
      editCase ( id ) {
        const editLink = this.editLink( id );
        this.$router.push({path: editLink});
      },
      countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert () {
        this.alertIsShown = true
      },
      getCases (){
        let self = this;  
        axios.get('/api/certifications/reports?token='+ localStorage.getItem("api_token"))
        .then(function (response) {
          self.loading = false;
          self.items = response.data.certifications.map((item) => {
            const [cday, cmonth, cyear] = item.certification_date.split('/');
            const cformattedDate = `${cyear}-${cmonth}-${cday}`;
            const cdate = new Date(cformattedDate).getTime();

            const [eday, emonth, eyear] = item.expiration_date.split('/');
            const eformattedDate = `${eyear}-${emonth}-${eday}`;
            const edate = new Date(eformattedDate).getTime();
            return {
                'id' : item.id,
                'certificate_no' : item.certificate_no,
                'company_name' : item.company_name,
                'service' : item.service.name,
                'certification_date' : cdate,
                'expiration_date' : edate,
            };
          });
          }).catch(function (error) {
            self.loading = false;
            self.$router.push({ path: '/login' });
          });
      },
        setDateFilter (e, end) {
           
            if (end) {
                if(e.target.value == "Invalid date" || !e.target.value){
                    this.endDate = null
                }else{
                    this.endDate = moment(new Date(e.target.value)).format('YYYY-MM-DD')
                }
            } else {
                if(e.target.value == "Invalid date" || !e.target.value){
                    this.startDate = null
                }else{
                    this.startDate = moment(new Date(e.target.value)).format('YYYY-MM-DD')
                }
            }
        },
      xlsCode () {
        this.tempArr = this.dateFilteredItems.map((item) => {
            return {
            'Αρ. Πιστοποιητικού': item.certificate_no,
            'Πελάτης': item.company_name,
            'Πρότυπο': item.service,
            'Ημερομηνία Έκδοσης': new Date(item.certification_date).toLocaleString().split(',')[0],
            'Ημερομηνία Λήξης': new Date(item.expiration_date).toLocaleString().split(',')[0],
            }
        });

        try {
            js2excel.json2excel({
                data: this.tempArr,
                name: 'certificaions-data',
                formateDate: 'dd/mm/yyyy'
            });
        } catch (e) {
            console.error('export error: ', e);
        }
    },

    },
    mounted: function(){
      this.getCases();

    }
  }
  </script>